import isString from 'lodash/isString'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { getAppointmentConfirmationFormValues, getAppointmentFormValues } from './selectors'
import { getSelectedVehicle } from 'components/VehicleDetails/selectors'
import { preparePhoneNumber } from 'helpers/phone-number'
import { getUserData } from 'components/Appointment/selectors'

dayjs.extend(customParseFormat)

export const generateServices = ({ products = [], services = []}) =>
  [...products, ...services]
    .map(({ productName, qty, name }) => productName ? `${qty}, ${productName}` : name)
    .join(', ')

export const storeAppointmentContactDetails = ({
  contactDetails: {
    firstName,
    lastName,
    phoneNumber,
    email
  } = {},
  setAppointmentConfirmationContactDetails
}) => {
  if (isString(firstName) || isString(lastName) || isString(phoneNumber) || isString(email)) {
    setAppointmentConfirmationContactDetails({ firstName, lastName, phoneNumber, email })
  }
}

export const calculateStickyTop = (isStoreSelected, isHeaderSticky) => {
  let stickyTop = 0
  if (isStoreSelected) {
    stickyTop = isHeaderSticky ? '-55px' : '-2px'
  } else {
    stickyTop = isHeaderSticky ? '69px' : '120px'
  }
  return stickyTop
}

export const createAppointmentSchedulingPayload = (state) => {
  const { shoppingData } = state
  const { services, quoteSummary } = shoppingData.quotedItemAndServices
  const { appointmentDate: { date, time: { value }}} = getAppointmentFormValues(state)
  const { ntwBufferDays } = getUserData(state)
  const {
    phoneNumber,
    firstName,
    lastName,
    userPlan,
    email,
    promonOffers,
    termsConditions
  } = getAppointmentConfirmationFormValues(state)
  const addedSkus = state.addToQuote.skusAddedToCart
  const { storeNumber, owner: { email: storeEmail }} = state.myStore
  const { modelDesc, yearDesc, makeDesc, subModelDesc } = getSelectedVehicle(state)
  const selectedDate = dayjs(date).format('YYYY-MM-DD')
  const appointmentDateFormat = 'YYYY-MM-DDTHH:mm:ss.000[Z]'
  const resultServices = services ? services.map((service) => service.name) : []
  resultServices.push(`Estimate Total - ${quoteSummary.estimatedTotal}`)
  return {
    schedulingAppointmentPayload: {
      appointment: {
        appointmentDate: dayjs(`${selectedDate} ${value}`, 'YYYY-MM-DD H:mm a').format(appointmentDateFormat),
        appointmentRequestDate: dayjs().format(appointmentDateFormat),
        apptLength: 30,
        isDropOff: userPlan === 'dropOff',
        pickupDateTime: dayjs().format(appointmentDateFormat)
      },
      customer: {
        customerFName: firstName,
        customerLName: lastName,
        email,
        phone: phoneNumber
      },
      services: resultServices,
      poNumber: '',
      store: {
        defaultWarehouse: '1',
        email: storeEmail,
        number: storeNumber
      },
      storeNumber,
      tires: [...addedSkus],
      vehicle: {
        make: makeDesc,
        model: modelDesc,
        option: subModelDesc,
        year: yearDesc
      },
      delayInDaysNTWAvailability: ntwBufferDays
    },
    orderConfirmationPayload: {
      appointmentDateText: dayjs(date).format('MM/DD/YYYY'),
      appointmentTimeText: value,
      firstName,
      lastName,
      userPlan,
      email,
      promonOffers,
      termsConditions,
      ...preparePhoneNumber(phoneNumber)
    }
  }
}
